export default {
  lang: {
    reset: 'Reset',
    search: 'Filter',
    expand: 'Uitbreiden',
    collapse: 'Stow',
  },
};
